import styled from "styled-components";

export default styled.div`
  background-color: #fafbfc;
  padding: 15px ${props => props.theme.spaces[7]}px;
  color: #6c767e;
  text-transform: capitalize;
`;
